import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import { invoiceListClearFilters, invoiceListSetFilters, invoiceListUnload } from '../../../lib/redux/actions/invoices';
import { invoicePayorTypeListFetch } from '../../../lib/redux/actions/invoicePayorType';
import Form from 'react-bootstrap/Form';
import ConsultantTypeahead from '../../fields/ConsultantTypeahead';
import AssignToUserTypeahead from '../../fields/AssignToUserTypeahead';
import HospitalTypeahead from '../../fields/HospitalTypeahead';
import { renderField, renderSelect } from '../../../lib/helper/form';
import MASpinner from '../../common/MASpinner';
import { isSeniorStaff } from '../../../lib/helper/authorisation';
import { userNameFormatter } from '../../../lib/helper/formatting';
import { invoiceEscalationReasonFetch } from '../../../lib/redux/actions/invoiceEscalationReason';
import { invoiceEscalationStatusFetch } from '../../../lib/redux/actions/invoiceEscalationStatus';
import { consultantListFetch } from '../../../lib/redux/actions/consultant';
import { userListFetch } from '../../../lib/redux/actions/userList';
import { hospitalListFetch } from '../../../lib/redux/actions/hospitals';
import { getFiltersFromSession } from '../../../lib/routing/filters';
import { INVOICES } from '../../../lib/routing/frontend';

const validate = (values, props) => {
  const errors = {};
  if (values['outstandingBalance(gte)'] && values['outstandingBalance(lte)'] && values['outstandingBalance(lte)'] < values['outstandingBalance(gte)']) {
    errors['outstandingBalance(lte)'] = 'Less than must be smaller than greater than';
    errors['outstandingBalance(gte)'] = 'Less than must be smaller than greater than';
  }

  // Require hospital selection on hospital bulk chase page
  if (props.location && props.location.includes(INVOICES.HOSPITAL_BULK_CHASE.replace('/:page?', ''))) {
    if (!props.selectedHospitals || props.selectedHospitals.length === 0) {
      errors['hospital'] = 'Hospital selection is required for bulk chase';
    }
  }

  return errors;
};
const mapStateToProps = (state, ownProps) => {
  const { pageType, defaultFilters, location } = ownProps;

  let isEscalated = pageType === 'escalation' || (defaultFilters.hasOwnProperty('isEscalated') && defaultFilters.isEscalated) ? 1 : null;
  if (isEscalated === null && defaultFilters.hasOwnProperty('isEscalated') && !defaultFilters.isEscalated) {
    isEscalated = 0;
  }
  let isMissingContactDetails =
    pageType === 'missing' || (defaultFilters.hasOwnProperty('isMissingContactDetails') && defaultFilters.isMissingContactDetails) ? 1 : null;
  if (isMissingContactDetails === null && defaultFilters.hasOwnProperty('isMissingContactDetails') && !defaultFilters.isMissingContactDetails) {
    isMissingContactDetails = 0;
  }

  let initialValuesFromSession = getFiltersFromSession(location, 'json');
  let initialValues = {
    //    invoiceNo: state?.invoices?.filters?.invoiceNo,
    isPaid: pageType === 'missing' || pageType === 'escalation' ? null : false,
    'outstandingBalance(gt)': pageType === 'missing' || pageType === 'escalation' ? Number(0) : undefined,
    isEscalated: isEscalated,
    isMissingContactDetails: isMissingContactDetails,
    isVoid: !!defaultFilters.isVoid,
    ...initialValuesFromSession,
    ...state?.invoices?.filters,
  };
  delete initialValues['outstandingBalance(gte)'];
  delete initialValues['outstandingBalance(lte)'];
  if (initialValuesFromSession && null !== initialValuesFromSession['outstandingBalance(gte)']) {
    initialValues['outstandingBalance(gte)'] = initialValuesFromSession['outstandingBalance(gte)'] / 100;
  } else {
    initialValues['outstandingBalance(gte)'] = state?.invoices?.filters['outstandingBalance(gte)']
      ? state.invoices.filters['outstandingBalance(gte)'] / 100
      : undefined;
  }
  if (initialValuesFromSession && null !== initialValuesFromSession['outstandingBalance(lte)']) {
    initialValues['outstandingBalance(lte)'] = initialValuesFromSession['outstandingBalance(lte)'] / 100;
  } else {
    initialValues['outstandingBalance(lte)'] = state?.invoices?.filters['outstandingBalance(gte)']
      ? state.invoices.filters['outstandingBalance(lte)'] / 100
      : undefined;
  }
  return {
    initialValues,
    ...state.invoicePayorTypeList,
    ...state.invoiceEscalationReason,
    ...state.invoiceEscalationStatus,
    ...state.consultantList,
    ...state.userList,
    ...state.hospitals,
    //    isPaid: 0,
    //    isVoid: 0,
    selectedConsultants: initialValues && null !== initialValues['consultant.id'] ? initialValues['consultant.id'] : [],
    selectedAssignedToUsers: initialValues && null !== initialValues['assignedTo'] ? initialValues['assignedTo'] : [],
    selectedHospitals: initialValues && null !== initialValues['hospital.id'] ? initialValues['hospital.id'] : [],
  };
};
const mapDispatchToProps = {
  invoiceListSetFilters,
  invoiceListClearFilters,
  invoiceListUnload,
  invoicePayorTypeListFetch,
  invoiceEscalationReasonFetch,
  invoiceEscalationStatusFetch,
  consultantListFetch,
  userListFetch,
  hospitalListFetch,
};

class InvoiceTableFilterForm extends React.Component {
  constructor(props) {
    super(props);

    const { invoicePayorTypeListFetch, invoiceEscalationReasonFetch, invoiceEscalationStatusFetch, consultants = [] } = this.props;

    invoicePayorTypeListFetch();
    invoiceEscalationReasonFetch();
    invoiceEscalationStatusFetch();

    this.state = {
      selectedConsultants: consultants,
      selectedAssignedToUsers: [],
      selectedHospitals: [],
      clearTypeaheads: false,
      isLoadingConsultants: false,
      isLoadingAssignedUsers: false,
      isLoadingHospitals: false,
    };
  }

  componentDidMount() {
    const { selectedConsultants = [], selectedAssignedToUsers = [], selectedHospitals = [] } = this.props;
    // Fetch consultant objects if IDs are present
    if (selectedConsultants.length > 0) {
      this.setState({ isLoadingConsultants: true });
      this.props.consultantListFetch(null, {
        pagination: false,
        id: selectedConsultants,
      });
    }

    // Fetch assigned user objects if IDs are present
    if (selectedAssignedToUsers.length > 0) {
      this.setState({ isLoadingAssignedUsers: true });
      this.props.userListFetch(null, {
        pagination: false,
        id: selectedAssignedToUsers,
      });
    }

    // Fetch hospital objects if IDs are present
    if (selectedHospitals.length > 0) {
      this.setState({ isLoadingHospitals: true });
      this.props.hospitalListFetch(1, {
        pagination: false,
        id: selectedHospitals,
      });
    }
  }

  componentDidUpdate(prevProps) {
    // Handle consultant data loading
    if (prevProps.consultants !== this.props.consultants && this.props.consultants.length > 0 && this.state.isLoadingConsultants) {
      this.setState({
        selectedConsultants: this.props.consultants,
        isLoadingConsultants: false,
      });
    }

    // Handle assigned user data loading
    if (prevProps.users !== this.props.users && this.props.users.length > 0 && this.state.isLoadingAssignedUsers) {
      this.setState({
        selectedAssignedToUsers: this.props.users,
        isLoadingAssignedUsers: false,
      });
    }

    // Handle fetch failures for consultants
    if (prevProps.consultantsError !== this.props.consultantsError && this.props.consultantsError && this.state.isLoadingConsultants) {
      console.warn('Failed to load consultant data for filters');
      this.setState({
        isLoadingConsultants: false,
        selectedConsultants: [],
      });
    }

    // Handle fetch failures for assigned users
    if (prevProps.usersError !== this.props.usersError && this.props.usersError && this.state.isLoadingAssignedUsers) {
      console.warn('Failed to load assigned user data for filters');
      this.setState({
        isLoadingAssignedUsers: false,
        selectedAssignedToUsers: [],
      });
    }

    // Handle hospital data loading
    if (prevProps.hospitals !== this.props.hospitals && this.props.hospitals.length > 0 && this.state.isLoadingHospitals) {
      this.setState({
        selectedHospitals: this.props.hospitals.filter((hospital) => this.props.selectedHospitals.includes(hospital['@id'])),
        isLoadingHospitals: false,
      });
    }

    // Handle fetch failures for hospitals
    if (prevProps.hospitalsError !== this.props.hospitalsError && this.props.hospitalsError && this.state.isLoadingHospitals) {
      console.warn('Failed to load hospital data for filters');
      this.setState({
        isLoadingHospitals: false,
        selectedHospitals: [],
      });
    }
  }

  clearTypeaheads() {
    this.setState(() => {
      return {
        clearTypeaheads: true,
        isPaidToggledOn: 0,
        isVoidToggledOn: 0,
        isWrittenOffToggledOn: 0,
        isLoadingConsultants: false,
        isLoadingAssignedUsers: false,
        isLoadingHospitals: false,
      };
    });
  }

  typeaheadCleared() {
    if (this.state.clearTypeaheads) {
      this.setState(() => {
        return { clearTypeaheads: false };
      });
    }
  }

  onSubmit(values) {
    const { setPage, location } = this.props;
    const submitValues = { ...values };
    if (this.state.selectedConsultants.length) {
      submitValues['consultant.id'] = this.state.selectedConsultants.map((c) => c['@id']);
    }
    if (this.state.selectedAssignedToUsers.length) {
      submitValues['assignedTo'] = this.state.selectedAssignedToUsers.map((u) => u['@id']);
    }
    if (this.state.selectedHospitals.length) {
      submitValues['hospital.id'] = this.state.selectedHospitals.map((h) => h['@id']);
    }

    if (values['isPaid'] === '1' || values['isPaid'] === true) {
      submitValues['outstandingBalance(gt)'] = '-1';
      delete submitValues['outstandingBalance(gte)'];
      delete submitValues['outstandingBalance(lte)'];
      delete submitValues['daysOutstanding(gt)'];
      delete submitValues['daysOutstanding(lte)'];
      delete values['outstandingBalance(gt)'];
      delete values['outstandingBalance(gte)'];
      delete values['outstandingBalance(lte)'];
    } else if (String(values['outstandingBalance(gte)']) !== '') {
      const val = Number(values['outstandingBalance(gte)']) * 100;
      if (!isNaN(val)) {
        submitValues['outstandingBalance(gte)'] = val; // Number(values['outstandingBalance(gte)']) * 100;
      } else {
        delete values['outstandingBalance(gte)'];
      }
    }
    if (String(values['outstandingBalance(lte)']) !== '') {
      const val = Number(values['outstandingBalance(lte)']) * 100;
      if (!isNaN(val)) {
        submitValues['outstandingBalance(lte)'] = val; //Number(values['outstandingBalance(lte)']) * 100;
      } else {
        delete values['outstandingBalance(lte)'];
      }
    }
    let daysOSGT = Number(values['daysOutstanding(gt)']);
    let daysOSLTE = Number(values['daysOutstanding(lte)']);
    if (daysOSGT > daysOSLTE) {
      // swap the values - this is wrong way round
      const temp = daysOSGT;
      daysOSGT = daysOSLTE;
      daysOSLTE = temp;
    }
    if (daysOSGT > 0) {
      // get today minus daysOutstanding(gte) days
      const todayMinusXDays = new Date();
      todayMinusXDays.setDate(todayMinusXDays.getDate() - daysOSGT + 1);
      submitValues['invoiceDate(strictly_before)'] = todayMinusXDays.toISOString().split('T')[0];
      submitValues['isPaid'] = 0;
      submitValues['isVoid'] = 0;
      submitValues['isWrittenOff'] = 0;
      //      delete submitValues['daysOutstanding(gt)'];
    }

    if (daysOSLTE > 0) {
      //       get today minus daysOutstanding(lte) days
      const todayMinusXDays = new Date();
      todayMinusXDays.setDate(todayMinusXDays.getDate() - daysOSLTE); // -1 to make it inclusive
      submitValues['invoiceDate(after)'] = todayMinusXDays.toISOString().split('T')[0];
      submitValues['isPaid'] = 0;
      submitValues['isVoid'] = 0;
      submitValues['isWrittenOff'] = 0;
      //      delete submitValues['daysOutstanding(lte)'];
    }

    if (values['id']) {
      submitValues['id'] = values['id'].replace(/\D/g, '');
    }

    // attempt to stop extra filter values being applied when the filter shouldn't show (if there are problems with invoice filters look here)
    const filtersToShow = this.getFiltersToShow();
    if (!filtersToShow.isPaid) {
      delete submitValues['isPaid'];
    }
    if (!filtersToShow.isVoid) {
      delete submitValues['isVoid'];
    }
    if (submitValues['outstandingBalance(gt)'] === undefined || isNaN(submitValues['outstandingBalance(gt)'])) {
      delete submitValues['outstandingBalance(gt)'];
    }
    if (submitValues['outstandingBalance(gte)'] === undefined || isNaN(submitValues['outstandingBalance(gte)'])) {
      delete submitValues['outstandingBalance(gte)'];
    }
    if (submitValues['outstandingBalance(lte)'] === undefined || isNaN(submitValues['outstandingBalance(lte)'])) {
      delete submitValues['outstandingBalance(lte)'];
    }
    if (!filtersToShow.invoiceNo || submitValues['invoiceNo'] === undefined) {
      delete submitValues['invoiceNo'];
    }
    if (!filtersToShow.isPartPaid || submitValues['isPartPaid'] === undefined) {
      delete submitValues['isPartPaid'];
    }
    if (!filtersToShow.isEscalated || submitValues['isEscalated'] === null) {
      delete submitValues['isEscalated'];
    }
    if (!filtersToShow.isMissingContactDetails || submitValues['isMissingContactDetails'] === null) {
      delete submitValues['isMissingContactDetails'];
    }

    setPage(1);
    return this.props.invoiceListSetFilters(submitValues, location);
  }

  resetFilters() {
    const { reset, invoiceListClearFilters, invoiceListUnload, setPage, location } = this.props;
    invoiceListClearFilters(location);

    // Clear loaded invoices on hospital bulk chase page
    if (location && location.includes('/credit-control/invoices/chase-hospital-batch')) {
      invoiceListUnload(false, location);
    }

    this.clearTypeaheads();
    this.setState(() => ({
      selectedConsultants: [],
      selectedAssignedToUsers: [],
      selectedHospitals: [],
    }));
    setPage(1);
    reset();
  }

  getFiltersToShow() {
    const { filterOverrides = {} } = this.props;

    return {
      ...{
        consultant: true,
        patientName: true,
        invoiceNo: true,
        id: true,
        assignToUser: true,
        isPaid: true,
        isWrittenOff: true,
        isPartPaid: true,
        isEscalated: true,
        isMissingContactDetails: true,
        escalationFilters: false,
        consultantContactedForMissingDetails: true,
        osBal: true,
        osDays: true,
        payorType: true,
        hospital: true,
      },
      ...filterOverrides,
    };
  }

  render() {
    const { handleSubmit, error, invoicePayorTypes = [], invoiceEscalationReasons = [], invoiceEscalationStatuses = [], pageType } = this.props;

    if (!invoicePayorTypes) {
      return <MASpinner />;
    }

    const boolOptions = [
      { value: true, text: 'Yes' },
      { value: false, text: 'No' },
    ];
    const paidOptions = [
      { value: true, text: 'Paid' },
      { value: false, text: 'Unpaid' },
    ];

    const invoiceEscalationReasonsOptions = [];
    invoiceEscalationReasons.forEach((reason) => {
      invoiceEscalationReasonsOptions.push({
        text: reason.reason,
        value: reason['@id'],
      });
    });

    const invoiceEscalationStatusOptions = [];
    invoiceEscalationStatuses.forEach((status) => {
      invoiceEscalationStatusOptions.push({
        text: status.status,
        value: status['@id'],
      });
    });

    const payorTypeOptions = [];
    invoicePayorTypes.forEach((payorType) => {
      payorTypeOptions.push({
        text: payorType.name,
        value: payorType['@id'],
      });
    });

    const filtersToShow = this.getFiltersToShow();

    return (
      <div>
        {error && <div className="alert alert-danger">{error}</div>}
        <Form onSubmit={handleSubmit(this.onSubmit.bind(this))} className="fake-inline form-data-filters row">
          <div className="col-sm-6 col-xl-2">
            {filtersToShow.hospital && isSeniorStaff() && (
              <HospitalTypeahead
                label="Hospital"
                shouldClear={this.state.clearTypeaheads}
                hasCleared={this.typeaheadCleared.bind(this)}
                selectedHospitals={this.state.selectedHospitals}
                isLoading={this.state.isLoadingHospitals}
                onChange={(selected) => {
                  this.setState(() => {
                    return {
                      selectedHospitals: selected,
                      isLoadingHospitals: false,
                    };
                  });
                }}
              />
            )}

            {filtersToShow.consultant && isSeniorStaff() && (
              <ConsultantTypeahead
                label="Consultant"
                shouldClear={this.state.clearTypeaheads}
                hasCleared={this.typeaheadCleared.bind(this)}
                selectedConsultants={this.state.selectedConsultants}
                isLoading={this.state.isLoadingConsultants}
                onChange={(selected) => {
                  this.setState(() => {
                    return {
                      selectedConsultants: selected,
                      isLoadingConsultants: false,
                    };
                  });
                }}
              />
            )}

            {filtersToShow.patientName && <Field name="patientName" label="Patient Name" id="patientName" type="text" component={renderField} />}
            {filtersToShow.assignToUser && isSeniorStaff() && (
              <AssignToUserTypeahead
                rolesToShow='["ROLE_ADMIN","ROLE_SENIOR_STAFF","ROLE_STAFF","ROLE_CHASER_OUTSOURCER"]'
                shouldClear={this.state.clearTypeaheads}
                labelKey={(option) => userNameFormatter(option, false)}
                hasCleared={this.typeaheadCleared.bind(this)}
                selectedAssignedToUsers={this.state.selectedAssignedToUsers}
                isLoading={this.state.isLoadingAssignedUsers}
                //                multiple={true}
                onChange={(selected) => {
                  this.setState(() => {
                    return {
                      selectedAssignedToUsers: selected,
                      isLoadingAssignedUsers: false,
                    };
                  });
                }}
                label="Assigned To"
              />
            )}
            {filtersToShow.payorType && <Field name="payorType" label="Payor Type" type="select" options={payorTypeOptions} component={renderSelect} />}
          </div>
          <div className={'col-sm-6 col-xl-2'}>
            {filtersToShow.dateRange && <Field name="serviceDate(after)" label="Service Date From" type="date" component={renderField} />}
            {filtersToShow.dateRange && <Field name="serviceDate(before)" label="Service Date To" type="date" component={renderField} />}
          </div>
          {filtersToShow.invoiceNo || filtersToShow.id || filtersToShow.isMissingContactDetails || filtersToShow.consultantContactedForMissingDetails ? (
            <div className="col-sm-6 col-xl-2">
              {filtersToShow.invoiceNo && <Field name="invoiceNo" label="Invoice #" id="invoiceNo" type="text" component={renderField} />}
              {filtersToShow.id && <Field name="id" label="item Id" id="itemID" type="text" component={renderField} />}
              {filtersToShow.isMissingContactDetails && (
                <Field name="isMissingContactDetails" label="Missing Contact Details?" type="select" options={boolOptions} component={renderSelect} />
              )}

              {filtersToShow.consultantContactedForMissingDetails && pageType === 'missing' ? (
                <>
                  <Field name="consultantContactedForMissingDetails" label="Consultant Contacted" options={boolOptions} component={renderSelect} />
                </>
              ) : null}
            </div>
          ) : null}

          {/*<div className="row">*/}
          {filtersToShow.isEscalated || filtersToShow.escalationFilters ? (
            <div className="col-sm-6 col-xl-2">
              {filtersToShow.isEscalated && <Field name="isEscalated" label="Escalated?" type="select" options={boolOptions} component={renderSelect} />}
              {filtersToShow.escalationFilters ? (
                <>
                  <Field
                    name="invoiceEscalationReason"
                    label="Escalation Reason"
                    type="select"
                    options={invoiceEscalationReasonsOptions}
                    component={renderSelect}
                  />
                  <Field
                    name="invoiceEscalationStatus"
                    label="Escalation Status"
                    type="select"
                    options={invoiceEscalationStatusOptions}
                    component={renderSelect}
                  />
                  <Field name="revisitDate" label="Revisit Date" type="date" component={renderField} />
                </>
              ) : null}
            </div>
          ) : null}

          {filtersToShow.isPaid || filtersToShow.isVoid || filtersToShow.isWrittenOff || filtersToShow.isPartPaid ? (
            <div className="col-sm-6 col-xl-2">
              {filtersToShow.isPaid && (
                <Field
                  name="isPaid"
                  label="Paid?"
                  type="select"
                  options={paidOptions}
                  value={this.state.isPaid}
                  component={renderSelect}
                  onChange={(e) => this.setState({ isPaid: e.currentTarget.value })}
                />
              )}
              {filtersToShow.isVoid && (
                <Field
                  name="isVoid"
                  label="Void?"
                  type="select"
                  options={boolOptions}
                  value={this.state.isVoid}
                  component={renderSelect}
                  onChange={(e) => this.setState({ isVoid: e.currentTarget.value })}
                />
              )}
              {filtersToShow.isWrittenOff && (
                <Field
                  name="isWrittenOff"
                  label="Written Off?"
                  type="select"
                  options={boolOptions}
                  value={this.state.isWrittenOff}
                  component={renderSelect}
                  onChange={(e) => this.setState({ isWrittenOff: e.currentTarget.value })}
                />
              )}
              {filtersToShow.isPartPaid && (
                <Field
                  name="isPartPaid"
                  label="Part Paid?"
                  type="select"
                  options={boolOptions}
                  value={this.state.isPartPaid}
                  component={renderSelect}
                  onChange={(e) => this.setState({ isPartPaid: e.currentTarget.value })}
                />
              )}
            </div>
          ) : null}

          <div className="col-sm-6 col-xl-2">
            {filtersToShow.osBal && this.state.isPaid !== '1' && (
              <>
                <Field name="outstandingBalance(gte)" label="O/S Bal Greater than" type={'number'} component={renderField} />
                <Field name="outstandingBalance(lte)" label="O/S Bal Less than" type={'number'} component={renderField} formLabelClasses={'pr-2'} />
              </>
            )}
            {filtersToShow.osDays && this.state.isPaid !== '1' && (
              <>
                <Field name="daysOutstanding(gt)" label="Days O/S More Than" type={'number'} component={renderField} />
                <Field name="daysOutstanding(lte)" label="Days O/S Less than" type={'number'} component={renderField} formLabelClasses={'pr-2'} />
              </>
            )}
          </div>
          {/*{this.state.isPaidToggledOn !== '1' &&*/}
          {/*    <Field name="outstandingBalance(gt)" label="Show Small Values?" showEmpty={false} type="select" options={smallValueOptions} component={renderSelect}/>*/}
          {/*}*/}

          <div className="col-sm-6 col-xl-2">
            <div className="filter-actions">
              <button type="submit" className="btn btn-primary btn-sm">
                Filter
              </button>
              <button type="button" className="btn btn-outlineUploaded Date To-danger btn-sm ml-2" onClick={this.resetFilters.bind(this)}>
                Reset
              </button>
            </div>
          </div>
        </Form>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  reduxForm({
    form: 'InvoiceTableFilterForm',
    enableReinitialize: true,
    validate,
  })(InvoiceTableFilterForm),
);
